module.exports = __webpack_public_path__ + "img/pengabdian.01df0ed7.jpeg";